import { DESIGN_SHEET_STATUS } from '../types/design-sheet.js';
import { canEditScope, isStageConfirmingRole, scopeOfStage } from './edit-scopes.js';
import { SHEET_SECTION, SHEET_SECTIONS } from './sheet-sections.js';
import { stageContentIssue } from './stage-content.js';
/** 岗位录入确认；送审、审批、最终 Tech Pack 与按轮次管理的 QC 保持独立。 */
export const WORK_COMPLETION_TARGETS = SHEET_SECTIONS
    .filter(def => def.enabled && [SHEET_SECTION.DESIGN, SHEET_SECTION.MATERIAL, SHEET_SECTION.PATTERN].includes(def.section))
    .flatMap(def => def.stages.map(stage => ({ section: def.section, stage })));
/** 用草稿状态只判职责归属；实际可写状态仍由 canEditScope / assertScopeWritable 检查。 */
export function workCompletionTargetsOf(role, assignment) {
    return WORK_COMPLETION_TARGETS.filter(({ section, stage }) => isStageConfirmingRole(section, stage, role)
        && canEditScope(scopeOfStage(section, stage), role, DESIGN_SHEET_STATUS.DRAFT, assignment));
}
export function workCompletionState(sheet, targets) {
    return targets.map(target => {
        const issue = stageContentIssue(target.section, target.stage, sheet);
        const storedCompleted = sheet.sectionStages.some(mark => mark.section === target.section && mark.stage === target.stage && mark.completed);
        return { ...target, issue, storedCompleted, completed: storedCompleted && !issue };
    });
}
//# sourceMappingURL=work-completion.js.map